import { render, staticRenderFns } from "./SendLogsTab.vue?vue&type=template&id=766b25d1"
import script from "./SendLogsTab.vue?vue&type=script&lang=js"
export * from "./SendLogsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports